// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"nq-z","imageAndVideoCount":"oq-z","imageAndVideoContainer":"pq-z","viewAllReviews":"qq-z"};